import {Component, ElementRef, Input, Output, EventEmitter, OnInit, OnDestroy, AfterViewInit} from '@angular/core';

import {HostListener, Inject} from '@angular/core';
import $ from 'jquery/dist/jquery.min.js';
import {Subject} from 'rxjs/Subject';
import {Utilities} from '../../utilities/utilities.model';

@Component({
	selector: 'amd-amd-sticky',
	template: '<ng-content></ng-content>'
})
export class AmdStickyComponent implements OnInit, OnDestroy, AfterViewInit {
	position: number;
	elementHeight: number;
	elementOffsetTop: number;
	elementOffset: number;

	@Input('sticky-zIndex') zIndex: number = 10;
	@Input('sticky-width') width: string = 'auto';
	@Input('sticky-offset-top') offsetTop: number = 0;
	@Input('sticky-offset-bottom') offsetBottom: number = 0;
	@Input('sticky-start') start: number = 0;
	@Input('sticky-class') stickClass: string = 'amd-bottom-nav--fixed';
	@Input('sticky-end-class') endStickClass: string = 'amd-bottom-nav--notfixed';
	@Input('sticky-media-query') mediaQuery: string = '';
	@Input('sticky-parent') parentMode: boolean = true;
	@Input('sticky-init') isDetailReady: boolean;

	@Input('on-scroll-bar') onScrollBarBind?: Subject<boolean>;

	@Output() activated = new EventEmitter();
	@Output() deactivated = new EventEmitter();
	@Output() reset = new EventEmitter();

	private onScrollBind: EventListener = this.onWindowScroll.bind(this);
	private onResizeBind: EventListener = this.onResize.bind(this);

	private isStuck: boolean = false;

	private elem: any;
	private container: any;
	private originalCss: any;

	private windowHeight: number;
	private containerHeight: number;
	private elemHeight: number;
	private containerStart: number;
	private scrollFinish: number;

	constructor(private element: ElementRef) {
	}

	ngOnInit(): void {

		this.elem = this.element.nativeElement;

		this.windowHeight = $(window).height();

		// todo: aggiungere check chiamate api detail
		setTimeout(() => {
			this.sticker();
		}, 2500);
	}

	ngAfterViewInit(): void {

		this.container = this.elem.parentNode;
		if (!Utilities.isVoid(this.onScrollBarBind)) {
			this.onScrollBarBind.subscribe(x => this.onWindowScroll());
		}

	}

	ngOnDestroy(): void {
		window.removeEventListener('scroll', this.onScrollBind);
		window.removeEventListener('resize', this.onResizeBind);
	}

	@HostListener('document:keydown', ['$event'])
	@HostListener('window:wheel', ['$event'])
	onWindowScroll() {
		//this.windowHeight = $(window).height();
		this.sticker();
	}

	/*@HostListener('window:scroll', ['$event'])
	onWindowScroll() {
		//    this.windowHeight = $(window).height();

		this.sticker();
	}*/

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.windowHeight = $(window).height();
		this.sticker();
	}


	public sticker(): void {
		let position: number = 1;

		const offset = $('.amd-bottom-nav--floated').offset();
		if (!Utilities.isVoid(offset)) {
			this.offsetTop = offset.top;

			position = (this.offsetTop + $('.amd-bottom-nav--floated').height() / 2) - this.windowHeight;
			//check changing height container

			if (position < 0) {
				$('.amd-bottom-nav--fixed').hide();
			} else {
				$('.amd-bottom-nav--fixed').show();
			}
		}
	}

	matchMediaQuery(): any {
		if (!this.mediaQuery) return true;
		return (
			window.matchMedia('(' + this.mediaQuery + ')').matches ||
			window.matchMedia(this.mediaQuery).matches
		);
	}

	private scrollbarYPos(): number {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	private getBoundingClientRectValue(element: any, property: string): number {
		let result = 0;
		if (element.getBoundingClientRect) {
			let rect = element.getBoundingClientRect();
			result = (typeof rect[property] !== 'undefined') ? rect[property] : 0;
		}
		return result;
	}

	private getCssValue(element: any, property: string): any {
		let result: any = '';
		if (typeof window.getComputedStyle !== 'undefined') {
			result = window.getComputedStyle(element, null).getPropertyValue(property);
		}
		else if (typeof element.currentStyle !== 'undefined') {
			result = element.currentStyle[property];
		}
		return result;
	}

	private getCssNumber(element: any, property: string): number {
		return parseInt(this.getCssValue(element, property), 10) || 0;
	}

}